import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/swallacemeeting/bizdevconsult';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'NIMBLE', href: '#nimble' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Results', href: '#results' },
  { label: 'FAQ', href: '#faq' },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="header"
      className="fixed top-0 w-full z-50 backdrop-blur-lg bg-white/90 border-b border-gray-100"
    >
      <div className="container">
        <nav className="flex items-center justify-between h-16" aria-label="Main navigation">
          <a href="#" className="flex-shrink-0" aria-label="B2B Rev Co home">
            <img
              src="https://customer-assets.emergentagent.com/job_smb-sales-service/artifacts/jgq0w3mu_logo-removebg-preview.png"
              alt="B2B Rev Co Logo"
              className="h-10 w-auto"
              style={{ filter: 'invert(1)' }}
            />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-medium transition-colors"
                style={{ color: 'var(--text-secondary)' }}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm px-5 py-2.5"
              data-testid="nav-book-call"
              aria-label="Book a call"
            >
              Book a Call
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6 text-gray-700" /> : <Menu className="w-6 h-6 text-gray-700" />}
          </button>
        </nav>

        {/* Mobile nav */}
        {open && (
          <div className="md:hidden pb-4 border-t border-gray-100" data-testid="mobile-menu">
            <div className="flex flex-col gap-3 pt-4">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm font-medium py-2 px-1"
                  style={{ color: 'var(--text-secondary)' }}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-sm text-center mt-2"
              >
                Book a Call
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
